import client from "api/client";


const _client = client.route("/d1/auth");

const auth = {
	otp: (payload) => _client.post("/otp", payload),
	eval: (payload) => _client.post("/otp/eval", payload),
	signup: (payload) => _client.post("/otp/signup", payload),
	logout: (payload) => _client.post("/logout", payload)
};

export default auth;